<script setup lang="ts">
import type { CardPassThroughOptions } from 'primevue/card';

import type {
  ICardProps,
  ICardSlots,
  VCardType,
} from './types';

withDefaults(defineProps<ICardProps>(), {
  type: 'default',
});
defineSlots<ICardSlots>();

const pt: { [K in VCardType]: CardPassThroughOptions | undefined } = {
  table: { content: { class: '!p-0' }, body: { class: '!p-0' }, title: { class: 'word-break' } },
  default: { root: { class: 'overflow-hidden' }, title: { class: 'word-break' } },
  form: { root: { class: 'overflow-hidden' }, title: { class: 'min-h-[39px] word-break' } },
};
</script>

<template>
  <PCard v-data-qa-auto-id="'VCard'"
    :pt="pt[type]"
  >
    <template
      v-if="title || $slots.title"
      #title
    >
      <slot name="title">
        {{ title }}
      </slot>
    </template>
    <template #content>
      <slot />
    </template>
    <template
      v-if="$slots.footer"
      #footer
    >
      <slot name="footer" />
    </template>
  </PCard>
</template>
